import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const DeclarationAccessibilite = () => {
    const lastUpdate = "9 septembre 2025";

    const sections = [
        {
            id: "editeur",
            title: "1. Éditeur & Contact",
            content: `Les présentes Conditions Générales de Vente (CGV) sont proposées par :
      Gestion Freelance
      Siège social : 5 rue Gabriel Bourdarias, 69200 Vénissieux
      Téléphone : 06 03 84 73 69
      Email : contact@gestionfreelance.com.`,
        },
        {
            id: "objet",
            title: "2. Objet",
            content:
                "Les présentes CGV définissent les droits et obligations de Gestion Freelance et de ses clients dans le cadre de la fourniture de prestations de gestion comptable, d’accompagnement administratif et de solutions numériques destinées aux freelances et aux sociétés.",
        },
        {
            id: "prestations",
            title: "3. Prestations proposées",
            content:
                "Gestion Freelance propose notamment : Gestion comptable et administrative pour freelances et sociétés, accompagnement à la facturation, devis, déclarations et suivi, mise à disposition d’outils numériques adaptés (si applicable).",
        },
        {
            id: "commandes",
            title: "4. Commandes",
            content:
                "Toute commande de service implique l’acceptation sans réserve des présentes CGV. La commande est considérée comme ferme et définitive après signature d’un devis, validation électronique ou paiement.",
        },
        {
            id: "prix",
            title: "5. Prix et modalités de paiement",
            content:
                "Les prix sont indiqués en euros (€), hors taxes (HT), sauf mention contraire. Le règlement s’effectue selon les modalités précisées au devis (virement bancaire, carte bancaire, prélèvement). Tout retard de paiement entraîne l’application de pénalités légales ainsi qu’une indemnité forfaitaire de recouvrement (article L441-10 du Code de commerce).",
        },
        {
            id: "retractation",
            title: "6. Droit de rétractation (clients particuliers uniquement)",
            content:
                "Conformément aux articles L221-18 et suivants du Code de la consommation, le client particulier dispose d’un délai de 14 jours pour exercer son droit de rétractation, sauf si l’exécution du service a commencé avec son accord avant l’expiration de ce délai.",
        },
        {
            id: "responsabilite",
            title: "7. Responsabilité",
            content:
                "Gestion Freelance s’engage à fournir ses services avec diligence et professionnalisme. Toutefois, l’entreprise ne peut être tenue responsable : des erreurs liées aux informations transmises par le client, des conséquences fiscales ou juridiques en cas de manquement légal du client.",
        },
        {
            id: "confidentialite",
            title: "8. Confidentialité",
            content:
                "Toutes les données transmises par le client sont strictement confidentielles et utilisées uniquement pour l’exécution des prestations.",
        },
        {
            id: "propriete",
            title: "9. Propriété intellectuelle",
            content:
                "Les méthodes, modèles et outils fournis par Gestion Freelance restent sa propriété exclusive. Toute reproduction ou diffusion sans autorisation est interdite.",
        },
        {
            id: "resiliation",
            title: "10. Résiliation",
            content:
                "Chaque partie peut mettre fin au contrat à tout moment, sans préavis ni indemnité, par simple notification écrite (courrier ou email).",
        },
        {
            id: "donnees",
            title: "11. Données personnelles (RGPD)",
            content:
                "Gestion Freelance collecte et traite les données personnelles de ses clients conformément au RGPD. Le client dispose d’un droit d’accès, de rectification et de suppression en écrivant à : contact@gestionfreelance.com.",
        },
        {
            id: "droit",
            title: "12. Loi applicable et juridiction compétente",
            content:
                "Les présentes CGV sont régies par le droit français. Tout litige sera porté devant les tribunaux compétents du ressort de Lyon.",
        },
    ];

    return (
        <>
            <Navbar />
            <main
                className="min-h-screen bg-white font-Poppins lg:pt-20 pt-10"
                id="cgv"
            >
                <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-12">
                    {/* En-tête */}
                    <header className="mb-12 text-start ">
                        <h1 className="text-3xl sm:text-4xl font-bold lg:text-5xl font-Poppins tracking-tight text-color1 mb-3">
                            Conditions Générales de Vente (CGV)
                        </h1>

                        <p className="text-sm sm:text-base text-gray-600 font-thin">
                            Dernière mise à jour&nbsp;: {lastUpdate}
                        </p>
                    </header>

                    {/* Sommaire */}
                    <nav
                        aria-label="Sommaire"
                        className="mb-10 rounded-2xl border border-color3 p-6 shadow-sm font-Poppins"
                    >
                        <h2 className="text-lg font-semibold text-color1 mb-4">Sommaire</h2>
                        <ul className="grid gap-3 sm:grid-cols-2">
                            {sections.map((s) => (
                                <li key={s.id}>
                                    <a
                                        href={`#${s.id}`}
                                        className="text-sm sm:text-base text-gray-700 hover:underline"
                                    >
                                        {s.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Contenu */}
                    <div className="space-y-12">
                        {sections.map((s) => (
                            <section key={s.id} id={s.id}>
                                <h3 className="text-2xl sm:text-3xl font-bold text-color1 mb-4 text-start font-Poppins">
                                    {s.title}
                                </h3>
                                <p className="text-gray-700 text-base sm:text-lg leading-relaxed text-justify font-Poppins">
                                    {s.content}
                                </p>
                            </section>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default DeclarationAccessibilite;
